var chunkMapping = {
	"webpack_container_remote_search_Vdp": [
		"webpack/container/remote/search/Vdp"
	],
	"webpack_container_remote_search_BrowseVehicles": [
		"webpack/container/remote/search/BrowseVehicles"
	],
	"webpack_container_remote_search_WatchlistIndicator": [
		"webpack/container/remote/search/WatchlistIndicator"
	],
	"webpack_container_remote_search_OrderTransport": [
		"webpack/container/remote/search/OrderTransport"
	],
	"webpack_container_remote_search_BidHistoryContent": [
		"webpack/container/remote/search/BidHistoryContent"
	],
	"webpack_container_remote_search_BidBuyUi": [
		"webpack/container/remote/search/BidBuyUi"
	],
	"webpack_container_remote_search_BuyPending": [
		"webpack/container/remote/search/BuyPending"
	],
	"webpack_container_remote_search_BuyClosing": [
		"webpack/container/remote/search/BuyClosing"
	]
};
var idToExternalAndNameMapping = {
	"webpack/container/remote/search/Vdp": [
		"default",
		"./Vdp",
		"webpack/container/reference/search"
	],
	"webpack/container/remote/search/BrowseVehicles": [
		"default",
		"./BrowseVehicles",
		"webpack/container/reference/search"
	],
	"webpack/container/remote/search/WatchlistIndicator": [
		"default",
		"./WatchlistIndicator",
		"webpack/container/reference/search"
	],
	"webpack/container/remote/search/OrderTransport": [
		"default",
		"./OrderTransport",
		"webpack/container/reference/search"
	],
	"webpack/container/remote/search/BidHistoryContent": [
		"default",
		"./BidHistoryContent",
		"webpack/container/reference/search"
	],
	"webpack/container/remote/search/BidBuyUi": [
		"default",
		"./BidBuyUi",
		"webpack/container/reference/search"
	],
	"webpack/container/remote/search/BuyPending": [
		"default",
		"./BuyPending",
		"webpack/container/reference/search"
	],
	"webpack/container/remote/search/BuyClosing": [
		"default",
		"./BuyClosing",
		"webpack/container/reference/search"
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}